import Vue from 'vue/dist/vue';
import { mapGetters, mapActions } from 'vuex';
import store from '@scripts/store';
import { VUEX_GETTERS, VUEX_ACTIONS, FAVORITE_STATES } from '@scripts/constants';
import { toggleFavorites } from '@scripts/mixins/toggle-favorites';
import { getFromBinding } from '@scripts/helpers';
import AddToCart from '../../components/add-to-cart/add-to-cart.vue';
import ProductStatus from '../../components/product-status/product-status.vue';

export default (el, name, data) =>
    new Vue({
        el,
        name,
        store,
        data() {
            return {
                isUserWholesaler: false,
            };
        },
        components: {
            AddToCart,
            ProductStatus,
        },
        mixins: [toggleFavorites()],
        beforeMount() {
            this.favoritesMap = data.favoritesMap;
            this.isUserWholesaler = getFromBinding('user.type') === 'wholesaler';
        },
        computed: {
            ...mapGetters([VUEX_GETTERS.CART_PRODUCT_QUANTITY, VUEX_GETTERS.CART_PRODUCT_LOADING_STATUS]),

            isFavoritesListEmpty() {
                return !Object.values(this.favoritesMap).some((item) => {
                    return item === FAVORITE_STATES.LIKED || item === FAVORITE_STATES.LOADING;
                });
            },
        },
        methods: {
            ...mapActions([VUEX_ACTIONS.CHANGE_CART_PRODUCT_QUANTITY]),

            isFavoriteRemoved(productId) {
                return this.favoritesMap[`id${productId}`] === FAVORITE_STATES.NOT_LIKED;
            },
        },
    });
